// extracted by mini-css-extract-plugin
export default {"NotificationDetails":"_4PkkSjPdlHouUTcaMl1ShA=="};